export default async function plugin<T extends unknown>(
  res: T,
  cbList: ((res: T) => T | Promise<T>)[],
): Promise<T> {
  for (const cb of cbList) {
    res = await cb(res)
  }
  return res
}
